import type { ConversationNodeDialInput } from 'lib-shared-types-api';

type RoutedThroughDialInputProps = {
  node: ConversationNodeDialInput;
};

export function RoutedThroughDialInput({
  node,
}: RoutedThroughDialInputProps): JSX.Element {
  return (
    <>
      Dial input <strong>{node.variable_id}</strong> ·{' '}
      <strong>{node.input}</strong>
    </>
  );
}
